(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fg-home-applications-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fg-field-film')) {
    customElements.define('fg-field-film', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.userPaused ??= false;
        const sync = () => {
          if (this.inView && !document.hidden && !this.motion.matches && !this.userPaused) {
            this.video.play()?.catch(() => {});
          } else if (!this.video.paused) {
            this.video.pause();
          }
        };
        this.video.addEventListener('pause', () => {
          if (this.inView && !document.hidden && !this.motion.matches && this.isConnected) this.userPaused = true;
        }, options);
        this.video.addEventListener('play', () => { this.userPaused = false; }, options);
        document.addEventListener('visibilitychange', sync, options);
        this.motion.addEventListener('change', sync, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            for (const entry of entries) {
              this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
              sync();
            }
          }, { threshold: [0, 0.2] });
          this.observer.observe(this);
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.inView = false;
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fg-home-cta-v4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fg-cta-gallery')) {
    customElements.define('fg-cta-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = Array.from(this.querySelectorAll('[data-cta-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-cta-panel]'));
        if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), { signal });
          tab.addEventListener('pointerenter', () => {
            if (matchMedia('(hover: hover) and (pointer: fine)').matches) this.select(index);
          }, { signal });
          tab.addEventListener('keydown', (event) => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next;
            if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
            this.tabs[next].scrollIntoView?.({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
          }, { signal });
        });
      }
      select(index) {
        this.tabs.forEach((tab, current) => {
          const active = current === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[current].classList.toggle('is-active', active);
          this.panels[current].setAttribute('aria-hidden', String(!active));
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fg-home-knowledge-v4"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fg-knowledge-compare')) {
    customElements.define('fg-knowledge-compare', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.stopMotion();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = Array.from(this.querySelectorAll('[data-compare-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-compare-panel]'));
        if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
        this.previewed ??= new WeakSet();
        this.reveals = new Map();
        this.motionPreference = window.matchMedia?.('(prefers-reduced-motion: reduce)');
        this.querySelectorAll('[data-compare-input]').forEach(input => {
          const frame = input.closest('[data-reveal]');
          const value = Number(input.value);
          const state = { input, frame, x: value, edge: value, target: value, keyboard: false,
            clip: frame.querySelector('[data-compare-clip]'), line: frame.querySelector('[data-compare-line]') };
          this.reveals.set(input, state);
          if (state.clip && state.line) frame.dataset.curved = '';
          this.syncReveal(input);
          input.addEventListener('input', () => this.syncReveal(input), { signal });
          input.addEventListener('focus', () => this.takeControl(state), { signal });
          input.addEventListener('keydown', () => { state.keyboard = true; this.takeControl(state); }, { signal });
          input.addEventListener('blur', () => { state.keyboard = false; }, { signal });
          frame.addEventListener('pointerdown', () => {
            state.keyboard = false;
            this.takeControl(state);
          }, { signal });
          frame.addEventListener('pointermove', event => this.followPointer(event, state), { signal, passive: true });
          frame.addEventListener('pointerleave', () => {
            if (state !== this.active || this.mode !== 'follow') return;
            state.target = state.x;
          }, { signal });
          frame.querySelectorAll('img').forEach(image => image.addEventListener('load', () => this.maybePreview(), { signal }));
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            for (const entry of entries) {
              if (entry.target !== this.active?.frame) continue;
              this.inView = entry.isIntersecting && entry.intersectionRatio >= .25;
              if (this.inView) this.maybePreview();
              else this.stopMotion();
            }
          }, { threshold: [0, .25] });
        }
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopMotion();
          else this.maybePreview();
        }, { signal });
        this.motionPreference?.addEventListener('change', () => {
          this.stopMotion();
          if (!this.motionPreference.matches) this.maybePreview();
        }, { signal });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), { signal });
          tab.addEventListener('keydown', event => {
            const rtl = getComputedStyle(this).direction === 'rtl';
            let next;
            if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            next = (next + this.tabs.length) % this.tabs.length;
            this.select(next);
            this.tabs[next].focus({ preventScroll: true });
          }, { signal });
        });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-compare-panel]');
          const index = this.panels.indexOf(panel);
          if (index >= 0) this.select(index);
        }, { signal });
        const selected = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
        this.select(selected >= 0 ? selected : 0, false);
        this.dataset.enhanced = '';
      }
      syncReveal(input) {
        const value = Math.max(0, Math.min(100, Number(input.value) || 0));
        const state = this.reveals.get(input);
        if (state === this.active) this.takeControl(state);
        state.x = state.edge = state.target = value;
        this.paint(state);
      }
      takeControl(state) {
        this.previewed.add(state.input);
        if (state === this.active) this.stopMotion();
      }
      followPointer(event, state) {
        if (state !== this.active || state.keyboard || document.hidden || event.buttons || !['mouse', 'pen'].includes(event.pointerType)) return;
        const bounds = state.frame.getBoundingClientRect();
        if (!bounds.width) return;
        this.previewed.add(state.input);
        if (this.mode === 'preview') this.stopMotion();
        state.target = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100));
        if (this.motionPreference?.matches) {
          state.x = state.edge = state.target;
          this.paint(state);
          return;
        }
        this.mode = 'follow';
        this.startMotion();
      }
      maybePreview() {
        const state = this.active;
        if (!this.isConnected || !state || !this.inView || document.hidden || this.motionPreference?.matches || this.previewed.has(state.input)) return;
        if (Array.from(state.frame.querySelectorAll('img')).some(image => !image.complete || !image.naturalWidth)) return;
        this.previewed.add(state.input);
        this.mode = 'preview';
        this.startMotion();
      }
      startMotion() {
        if (this.animationFrame) return;
        this.lastFrame = undefined;
        this.previewStart = undefined;
        const tick = time => {
          this.animationFrame = undefined;
          const state = this.active;
          if (!this.isConnected || !state || document.hidden || this.motionPreference?.matches) return;
          const delta = this.lastFrame === undefined ? 16 : Math.min(32, time - this.lastFrame);
          this.lastFrame = time;
          if (this.mode === 'preview') {
            this.previewStart ??= time;
            const progress = Math.min(1, (time - this.previewStart) / 3600);
            if (progress === 1) {
              state.x = state.edge = state.target = 50;
              this.paint(state);
              this.mode = undefined;
              return;
            }
            state.target = 50 + Math.sin(progress * Math.PI * 2) * Math.sin(progress * Math.PI) * 18;
          }
          state.x += (state.target - state.x) * (1 - Math.exp(-delta / 65));
          state.edge += (state.x - state.edge) * (1 - Math.exp(-delta / 150));
          state.edge = Math.max(state.x - 6, Math.min(state.x + 6, state.edge));
          if (this.mode !== 'preview' && Math.abs(state.target - state.x) < .015 && Math.abs(state.edge - state.x) < .015) {
            state.x = state.edge = state.target;
            this.paint(state);
            this.mode = undefined;
            return;
          }
          this.paint(state);
          this.animationFrame = requestAnimationFrame(tick);
        };
        this.animationFrame = requestAnimationFrame(tick);
      }
      stopMotion() {
        if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
        this.animationFrame = undefined;
        this.mode = undefined;
        if (this.active) {
          this.active.edge = this.active.x;
          this.paint(this.active);
        }
      }
      paint(state) {
        const value = Math.round(state.x * 1000) / 1000;
        state.frame.style.setProperty('--split', `${value}%`);
        state.input.value = String(Math.round(value));
        state.input.setAttribute('aria-valuetext', `${state.input.value}% ${state.input.dataset.beforeLabel}`);
        if (!state.clip || !state.line) return;
        const x = value / 100;
        const edge = Math.round(state.edge * 1000) / 100000;
        state.clip.setAttribute('d', `M0 0H${edge}C${edge} .18 ${x} .24 ${x} .5C${x} .76 ${edge} .82 ${edge} 1H0Z`);
        state.line.setAttribute('d', `M${edge * 1000} 0C${edge * 1000} 180 ${x * 1000} 240 ${x * 1000} 500C${x * 1000} 760 ${edge * 1000} 820 ${edge * 1000} 1000`);
      }
      select(index, eager = true) {
        this.stopMotion();
        this.observer?.disconnect();
        this.inView = false;
        this.tabs.forEach((tab, current) => {
          const selected = current === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[current].hidden = !selected;
          if (selected && eager) this.panels[current].querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
        });
        this.active = this.reveals.get(this.panels[index].querySelector('[data-compare-input]'));
        if (this.active) this.observer?.observe(this.active.frame);
      }
      disconnectedCallback() {
        this.stopMotion();
        this.observer?.disconnect();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fg-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fg-product-tabs')) {
    customElements.define('fg-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')]
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab))
          tab.addEventListener('keydown', (event) => this.onKeydown(event, tab))
        })
      }

      activate(activeTab) {
        this.tabs.forEach((tab) => {
          const selected = tab === activeTab
          tab.setAttribute('aria-selected', String(selected))
          tab.tabIndex = selected ? 0 : -1
          const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`)
          if (panel) panel.hidden = !selected
        })
      }

      onKeydown(event, tab) {
        const index = this.tabs.indexOf(tab)
        let next = index
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length
        if (event.key === 'Home') next = 0
        if (event.key === 'End') next = this.tabs.length - 1
        if (next !== index) {
          event.preventDefault()
          this.activate(this.tabs[next])
          this.tabs[next].focus()
        }
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
